import { Answer } from '../../types/api';
import {
    ApplicationAction,
    DELETE_DOCUMENT_SUCCESS,
    FETCH_APPLICATION_SUCCESS,
    FETCH_APPLICATION_FAIL,
    NO_QUESTION,
    POLICY_ACTION,
    PUT_POLICY_ACCEPT_SUCCESS,
    RETRY_ANSWER,
    SAVE_ANSWER_SUCCESS,
    SAVE_DOCUMENT_SUCCESS,
    SHOW_QUESTION,
    SUBMIT_APPLICATION_SUCCESS
} from './actions';
import { Application, ApplicationState, CandidateState, Document, Question, Vacancy } from './types';

const emptyVacancy: Vacancy = {
    name: '',
    videoReference: null
};

const emptyApplication: Application = {
    id: '',
    vacancy: emptyVacancy,
    firstName: '',
    lastName: '',
    emailAddress: '',
    applicationState: ApplicationState.CREATED,
    policyAccepted: false,
    questions: [],
    answers: [],
    documents: []
};

export const initialState: CandidateState = {
    application: emptyApplication,
    policyAgreeCheckbox: false,
    showPolicyCheckNotice: false,
    currentQuestion: undefined,
    currentAnswer: undefined,
    retryAnswer: false,
    loadError: false
};

export const isReadyToSubmit = (application: Application): boolean => {
    if (!application.policyAccepted) {
        return false;
    }
    if (
        application.applicationState !== ApplicationState.INVITATION_SENT &&
        application.applicationState !== ApplicationState.CREATED
    ) {
        return false;
    }
    if (application.questions.length > application.answers.length) {
        return false;
    }
    if (application.answers.filter(a => a.videoLink === undefined).length > 0) {
        return false;
    }
    return true;
};

export const isModifiable = (application: Application): boolean => {
    return (
        application.applicationState === ApplicationState.INVITATION_SENT ||
        application.applicationState === ApplicationState.CREATED
    );
};

const answerToQuestion = (application: Application, question: Question): Answer | undefined => {
    return application.answers.find(a => a.questionId === question.id);
};

export function reducer(state: CandidateState = initialState, action: ApplicationAction): CandidateState {
    switch (action.type) {
        case SUBMIT_APPLICATION_SUCCESS:
        case FETCH_APPLICATION_SUCCESS:
            return {
                ...state,
                application: action.payload.data
            };
        case POLICY_ACTION:
            return {
                ...state,
                policyAgreeCheckbox: action.payload.agree,
                showPolicyCheckNotice: !action.payload.agree && action.payload.clicked
            };
        case PUT_POLICY_ACCEPT_SUCCESS:
            return {
                ...state,
                application: {
                    ...state.application,
                    policyAccepted: true
                }
            };
        case SAVE_ANSWER_SUCCESS: {
            const persistedAnswer: Answer = action.payload.data;
            const newState = {
                ...state,
                currentAnswer: persistedAnswer,
                retryAnswer: false
            };
            newState.application.answers = state.application.answers.filter(a => a.id !== persistedAnswer.id);
            newState.application.answers.push(action.payload.data);
            return newState;
        }
        case SAVE_DOCUMENT_SUCCESS: {
            const newDocuments: Document[] = state.application.documents;
            newDocuments.push(action.payload.data);
            const newState = {
                ...state,
                application: {
                    ...state.application,
                    documents: newDocuments
                }
            };

            return newState;
        }
        case DELETE_DOCUMENT_SUCCESS: {
            const newDocuments: Document[] = state.application.documents.filter(
                d => d.id !== action.meta.previousAction.payload.id
            );
            return {
                ...state,
                application: {
                    ...state.application,
                    documents: newDocuments
                }
            };
        }
        case SHOW_QUESTION:
            return {
                ...state,
                currentQuestion: action.payload.question,
                currentAnswer: answerToQuestion(state.application, action.payload.question)
            };
        case NO_QUESTION:
            return {
                ...state,
                currentQuestion: undefined,
                currentAnswer: undefined
            };
        case RETRY_ANSWER: {
            return {
                ...state,
                retryAnswer: true
            };
        }
        case FETCH_APPLICATION_FAIL: {
            return {
                ...state,
                loadError: true
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/scenes/candidate/reducer.ts